import { get, post, put, del } from '../../api-config';
import { gdpService } from './_service';

// Patient health data
export const getPatientHealthData = (id: any) => get(gdpService, `/patients/${id}/health-data`, null, null);
export const putPatientHealthData = (id: any, path: any, data: any) =>
  put(gdpService, `/patients/${id}/health-data/${path}`, data, null);
export const delPatientHealthData = (id: any, valueId: any) =>
  del(gdpService, `/patients/${id}/health-data/${valueId}`);
export const getPatientHealthDataByPath = (id: any, path: any) =>
  get(gdpService, `/patients/${id}/health-data/${path}`, null, null);
export const postPatientHealthDataByPath = (id: any, path: any, data: any) =>
  post(gdpService, `/patients/${id}/health-data/${path}`, data, null);
export const putPatientHealthDataByPath = (id: any, path: any, fieldId: any, data: any) =>
  put(gdpService, `/patients/${id}/health-data/${path}/${fieldId}`, data, null);
export const delPatientHealthDataByPath = (id: any, path: any, fieldId: any) =>
  del(gdpService, `/patients/${id}/health-data/${path}/${fieldId}`);

// Patient personal info
export const getPatientInfoDataByPath = (id: any, path: any) =>
  get(gdpService, `/patients/${id}/personal-info/${path}`, null, null);
export const postPatientInfoDataByPath = (id: any, path: any, data: any) =>
  post(gdpService, `/patients/${id}/personal-info/${path}`, data, null);
export const putPatientInfoDataByPath = (id: any, path: any, fieldId: any, data: any) =>
  put(gdpService, `/patients/${id}/personal-info/${path}/${fieldId}`, data, null);
export const delPatientInfoDataByPath = (id: any, path: any, fieldId: any) =>
  del(gdpService, `/patients/${id}/personal-info/${path}/${fieldId}`);

// Patient personal data
export const getPatientPersonalData = (id: any) =>
  get(gdpService, `/patients/${id}/personal-data`, null, null);
export const postPatientPersonalData = (id: any, data: any) =>
  post(gdpService, `/patients/${id}/personal-data`, data, null);
export const putPatientPersonalData = (id: any, data: any) =>
  put(gdpService, `/patients/${id}/personal-data`, data, null);

// Patient health insurance
export const getPatientHealthInsurance = (id: any) =>
  get(gdpService, `/patients/${id}/health-insurance`, null, null);
export const putPatientHealthInsurance = (id: any, data: any) =>
  put(gdpService, `/patients/${id}/health-service`, data, null);
export const getPatientHealthService = (id: any) =>
  get(gdpService, `/patients/${id}/health-service`, null, null);
export const postPatientHealthService = (id: any, data: any) =>
  post(gdpService, `/patients/${id}/health-service`, data, null);
export const putPatientHealthService = (id: any, data: any) =>
  put(gdpService, `/patients/${id}/health-service`, data, null);
// Lista de selección rápida de un formulario del paciente (su grupo y ancestros, sin archivados).
export const getPatientQuickSelections = (id: any, type: string) =>
  get(gdpService, `/patients/${id}/quick-selections?type=${type}`, null, null);
// Contactos generales de grupo enlazables al paciente (su grupo y ancestros, sin archivados).
export const getPatientAvailableGroupGeneralContacts = (id: any) =>
  get(gdpService, `/patients/${id}/personal-info/general-contacts/available`, null, null);
// Servicios de grupo asignables al paciente (su grupo y ancestros, sin archivados).
export const getPatientAvailableGroupHealthServices = (id: any) =>
  get(gdpService, `/patients/${id}/health-service/available`, null, null);
export const delPatientHealthService = (data: any) =>
  del(gdpService, `/patients/${data.patientId}/health-service/${data.serviceId}`);

// Patient rules
export const getPatientRules = (id: any) =>
  get(gdpService, `/measures/patientRules?id=${id}`, null, null);
export const postPatientRules = (data: any) =>
  post(gdpService, `/measures/patientRules`, data, null);
export const putPatientRules = (data: any) =>
  put(gdpService, `/measures/patientRules`, data, null);
export const delPatientRules = (id: any) =>
  del(gdpService, `/measures/patientRules/${id}`);
